import { Select, Text, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import { useStores } from "../../store/store_context";
import { useEffect } from "react";

const SelectLeads = observer(() => {
  const { pageStore } = useStores();

  useEffect(() => {
    pageStore.updateSelectedTypeLeads("");
  }, []);

  return (
    <VStack>
      <Select
        style={{
          border: "none",
          background: "rgba(51,51,51,1)",
          color: "#EEEEEE",
          borderRadius: "10px",
          fontWeight: 600,
        }}
        placeholder="Не выбрано"
        width={"100%"}
        value={pageStore.selected_type_leads || ""}
        onChange={(e) => {
          const selectedValue = e.target.value;
          pageStore.updateSelectedTypeLeads(selectedValue || "");
        }}
      >
        <option
          style={{ background: "#0C0C0C", color: "#EEEEEE" }}
          value="Входящий лид"
        >
          Входящий лид
        </option>
        <option
          style={{ background: "#0C0C0C", color: "#EEEEEE" }}
          value="Исходящий лид"
        >
          Исходящий лид
        </option>
      </Select>
    </VStack>
  );
});

export default SelectLeads;
